var _path, _path2, _rect, _path3, _rect2, _path4, _rect3, _path5, _path6, _ellipse, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApiinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 426,
    viewBox: "0 0 426 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.59 350.484L60.122 200.42c-2.307-4.805-2.948-9.331-2.154-13.204l13.675-37.85 299.645 179.587-16.346 32.454c-2.597 5.284-8.445 8.726-16.696 8.941l-165.028 4.309c-15.285.399-33.026-10.424-39.628-24.173z",
    fill: "#53978E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.218 374.657l165.028-4.309c8.251-.215 14.099-3.657 16.696-8.941l16.346-32.454L71.643 149.366l-13.675 37.85c-.795 3.873-.153 8.399 2.154 13.204l73.468 150.064c6.602 13.749 24.343 24.572 39.628 24.173zm0 0l11.397-30.131",
    stroke: "#000",
    strokeWidth: 5.255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 103.814,
    height: 96.656,
    rx: 10.509,
    transform: "matrix(-.99966 .0261 .43283 .90148 244.085 217.201)",
    fill: "#BAD5D2",
    stroke: "#000",
    strokeWidth: 5.255
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.964 158.85c-5.02-10.455-18.483-18.686-30.07-18.383l-178.417 4.657c-11.587.303-16.91 9.024-11.89 19.48l77.005 160.382c5.02 10.456 18.483 18.687 30.07 18.384l178.417-4.658c11.587-.302 16.911-9.024 11.891-19.479L291.964 158.85z",
    fill: "#BAD5D2",
    stroke: "#000",
    strokeWidth: 5.255
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 58.907,
    height: 148.296,
    rx: 29.453,
    transform: "matrix(-.99966 .0261 .43283 .90148 217.386 173.787)",
    fill: "#797979",
    stroke: "#000",
    strokeWidth: 5.255
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230.143 200.352l38.675 80.549c7.045 14.673-.426 26.912-16.687 27.336-16.261.425-35.155-11.126-42.2-25.799l-19.337-40.274 24.107-58.953c6.673 4.536 12.263 10.521 15.442 17.141z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 5.255
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 38.935,
    height: 52.643,
    rx: 6.782,
    transform: "matrix(-.99966 .0261 .43283 .90148 135.954 169.644)",
    fill: "#FF8484",
    stroke: "#000",
    strokeWidth: 5.255
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.889 215.225l30.168-116.052 41.717-18.512L207.08 273.75l-27.191-58.525z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 5.086
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266.017 77.78c9.461 20.363.635 44.545-19.712 54.013-20.348 9.468-44.512.636-53.972-19.727-9.461-20.363-.636-44.546 19.712-54.014 20.347-9.468 44.511-.635 53.972 19.728z",
    fill: "#FF8484",
    stroke: "#000",
    strokeWidth: 5.086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.598,
    ry: 18.965,
    transform: "rotate(-24.953 316.37 -500.827) skewX(-.034)",
    fill: "#FFB5B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M283.255 186.652l-40.63 1.13M276.482 217.147l-20.315.566M286.642 237.479l-20.315.565M320.5 271.363l-40.63 1.13",
    stroke: "#000",
    strokeWidth: 6.782,
    strokeLinecap: "round"
  })));
}

export default SvgApiinline;